module.exports = __webpack_public_path__ + "img/withdrawicon.16f36266.svg";